import { render, staticRenderFns } from "./UpdateHolidayPlusChannel.vue?vue&type=template&id=674524f8&scoped=true"
import script from "./UpdateHolidayPlusChannel.vue?vue&type=script&lang=js"
export * from "./UpdateHolidayPlusChannel.vue?vue&type=script&lang=js"
import style0 from "./UpdateHolidayPlusChannel.vue?vue&type=style&index=0&id=674524f8&prod&lang=scss&scoped=true"
import style1 from "./UpdateHolidayPlusChannel.vue?vue&type=style&index=1&id=674524f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674524f8",
  null
  
)

export default component.exports